export default {
  generic_error: 'Qualcosa è andato storto',
  address_not_found:
    "Siamo spiacenti, non è stato possibile trovare l'indirizzo. Riprova inserendo prima la via nel campo di ricerca.",
  internal_error:
    'Purtroppo si è verificato un problema imprevisto con il tuo ordine, il nostro team tecnico ci sta già lavorando 🛠️.',
};
